export interface NavItem {
  name: string
  href: string
  icon?: string  // Giờ sẽ là class PrimeIcon như "pi pi-home"
  submenu?: NavItem[]  // Submenu items
}

// Menu cho người chưa đăng nhập
export const guestNavigationItems: NavItem[] = [
  {
    name: 'Trang Chủ',
    href: '/',
    icon: 'pi pi-home'
  },
  {
    name: 'Giới thiệu',
    href: '/about',
    icon: 'pi pi-info-circle'
  },
  {
    name: 'Khóa Học',
    href: '/course/online',
    icon: 'pi pi-book'
  },
  {
    name: 'Lớp học',
    href: '/classes',
    icon: 'pi pi-users'
  },
  {
    name: 'Liên hệ',
    href: '/contact',
    icon: 'pi pi-phone'
  }
]

// Menu cho người đã đăng nhập
export const authenticatedNavigationItems: NavItem[] = [
  {
    name: 'Trang Chủ',
    href: '/',
    icon: 'pi pi-home'
  },
  {
    name: 'Khóa Học',
    href: '/course/online',
    icon: 'pi pi-shopping-cart'
  },
  {
    name: 'Khóa học của tôi',
    href: '/course/my-courses',
    icon: 'pi pi-book'
  },
  {
    name: 'Nhóm Luyện Tập',
    href: '/training_groups',
    icon: 'pi pi-users'
  },
  {
    name: 'Xếp Hạng',
    href: '/leaderboard',
    icon: 'pi pi-trophy'
  },
  {
    name: 'Thử thách',
    href: '/challenges',
    icon: 'pi pi-star'
  },
  {
    name: 'Báo Cáo & Kháng Cáo',
    href: '/reports-appeals',
    icon: 'pi pi-flag'
  }
]

// Backward compatibility
export const navigationItems = guestNavigationItems
